export const OTHER_WORKS = 'Прочие работы';
